<ion-footer>
    <ion-toolbar (click)="filtersModal()">
        <ion-title>{{ filterCount }} <span *ngIf="filterCount !== 1"> {{ 'filters' | translate }}</span><span *ngIf="filterCount === 1"> {{ 'filter' | translate }}</span></ion-title>
        <ion-buttons slot="end">
            <ion-button color="primary">
                <ion-icon slot="icon-only" name="filter"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-footer>